import React, { useState } from 'react';
import styles from './SignOut.module.css';
import { axiosInstance } from '../../../../shared/api/axiosInstance';
import { toast } from 'react-toastify';
import { logout } from '../../../../shared/api/authApi';
import { useAppDispatch } from '../../../../store/store';
import { useNavigate } from 'react-router-dom';
import IconSettingSignout from '../../../../shared/ui/icons/IconSettingSignout';

export default function SignOut() {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const onSignOut = async () => {
        try {
            await axiosInstance.post('/auth/logout');
            localStorage.removeItem('authToken');

            await dispatch(logout());
            dispatch({ type: 'RESET_APP' });
            navigate('/login');
        } catch (error: any) {
            toast.error(error?.message || 'Failed to logout');
            console.error('Logout request failed:', error);
        }
    };

    return (
        <>
            <button className={styles.signout_btn} onClick={openModal}>
                <IconSettingSignout /> Sign out
            </button>

            {isOpen && (
                <div className={styles.overlay}>
                    <div className={styles.modal}>
                        <div className={styles.icon}>
                            <span className={styles.arrow}>
                                <IconSettingSignout color="#23262A" height={40} width={40} />
                            </span>
                        </div>
                        <p className={styles.message}>Are you sure you want to sign out?</p>
                        <div className={styles.actions}>
                            <button className={styles.cancelBtn} onClick={closeModal}>
                                Cancel
                            </button>
                            <button className={styles.confirmBtn} onClick={onSignOut}>
                                Sign out
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
